/**
 * Utility for merging class names
 * Simplified version without tailwind-merge (we use CSS modules)
 */
import { clsx, type ClassValue } from 'clsx';

export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}


